import { InterpolatedTranslatePipe } from '../../pipe/interpolated-translate.pipe';
import { Component, computed, inject, output, signal } from '@angular/core';
import { AvailableLanguage, LanguageService, WithNameAndIcon } from '@web/service';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { NgOptimizedImage } from '@angular/common';

interface ViewModel {
  availableLanguageWithNameAndIcons: Array<WithNameAndIcon>;
  selectedLanguage?: WithNameAndIcon;
}

@Component({
  selector: 'cas-language-picker',
  imports: [NgbDropdownModule, NgOptimizedImage, InterpolatedTranslatePipe],
  templateUrl: './language-picker.component.html',
})
export class LanguagePickerComponent {
  private languageService = inject(LanguageService);

  languageChanged = output<AvailableLanguage>();

  readonly flagSize = 20;

  readonly selectedLanguage = signal<AvailableLanguage>(this.languageService.currentLanguage());
  readonly viewModel = computed<ViewModel>(() => {
    const availableLanguages = this.languageService.availableLanguageWithNameAndIcons();
    return {
      availableLanguageWithNameAndIcons: availableLanguages,
      selectedLanguage: availableLanguages.find(l => l.language === this.selectedLanguage()),
    };
  });

  selectLanguage(language: WithNameAndIcon) {
    const currentSelectedLanguage = this.selectedLanguage();
    if (language.language !== currentSelectedLanguage) {
      this.languageService.changeLanguage(language.language).subscribe({
        complete: () => {
          this.onLanguageChange(this.languageService.currentLanguage());
        },
      });
    }
  }

  private onLanguageChange(language: AvailableLanguage) {
    this.selectedLanguage.set(language);
    this.languageChanged.emit(language);
  }
}
